<template>
  <component
    :is="componentType"
    :type="href ? null : type"
    :class="classes"
    :disabled="disabled"
    :href="href"
  >
    <component
      :is="props.leadingIcon"
      v-if="props.leadingIcon"
      :class="[
        props.size === 'xs' || props.size === 'sm' ? '-ml-0.5' : '-ml-1',
        props.size === 'xs' || props.size === 'sm' || props.size === 'md'
          ? 'mr-2'
          : 'mr-3',

        loadingSpinnerColor,
        iconSizeClasses(buttonSizeToIconSizeMap(props.size)),
      ]"
    />
    <template v-if="props.processing"
      ><LoadingSpinner
        class="mr-2 -ml-1"
        :color="loadingSpinnerColor"
        :size="buttonSizeToIconSizeMap(props.size)"
    /></template>
    <slot />
  </component>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import LoadingSpinner from '../LoadingSpinner.vue'
import { useButtonClasses } from './common'
import { iconSizeClasses, buttonSizeToIconSizeMap } from '../common'

const props = defineProps({
  type: {
    type: String,
    default: 'button',
  },
  href: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: 'md',
  },
  color: {
    type: String,
    default: 'default',
  },
  shape: {
    type: String,
    default: 'default',
  },
  rounded: {
    type: String,
    default: null,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  external: Boolean,
  leadingIcon: Function,
})

const classes = useButtonClasses(props)

const componentType = computed(() => {
  if (props.external) return 'a'

  return props.href ? Link : 'button'
})

const loadingSpinnerColor = computed(() => {
  if (props.color !== 'default') return 'text-gray-600 dark:text-white'
  else return 'text-white'
})
</script>
